import React, { Component } from 'react';
import LinkIcon from './LinkIcon';



export class VkGroupBlock extends React.Component {

    constructor(props) {
        super(props);
        
    }
    render() {
        return (
            <div  onClick={(e ) => { 
                this.props.chooseGroup(e, this.props.group_id ) 
                }}  className={this.props.group_id == this.props.chosen_group_id ? 'VkGroupsBlock_group VkGroupsBlock_group_chosen' : 'VkGroupsBlock_group' } >
                <img src={this.props.img} />
                <span className='VkGroupsBlock_group_name'>
                     <LinkIcon group_name={this.props.group_name} href={this.props.link}/>
                </span>
                
                <a href='#' onClick={(e ) => { 
                    this.props.chooseGroup(e, this.props.group_id ) 
                    }} className='btn1'>Выбрать</a>
            </div>
        )
    }
}